import { styled } from '@material-ui/core/styles';
const TopPixelFix = styled('div')(({ theme }) => ({
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '1px',
    backgroundColor: theme.palette.primary.light,
}));
export default TopPixelFix;
